import { ChapterGroupItem } from './ChapterGroupItem'
import { withChapterGroupItem } from './withChapterGroupItem'

const ConnectedChapterGroupItem = withChapterGroupItem(ChapterGroupItem)

export { ConnectedChapterGroupItem as ChapterGroupItem }
